import { PayloadAction } from '../../../store.model';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { filterRows } from '../function/filter-rows.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../landing.action';
import { LandingState } from '../landing.state';

import { ToggleGridShowAll } from './toggle-grid-show-all.action';

export function toggleGridShowAllReducer(
    state: LandingState,
    action: PayloadAction<
        ActionType.EVAL_LANDING__TOGGLE_GRID_SHOW_ALL,
        ToggleGridShowAll
    >,
): LandingState {
    const nextState: LandingState = { ...state };
    const ngo = createNextGridState(action.payload.type, state, nextState);
    ngo.showAll =
        action.payload.showAll != null ? action.payload.showAll : !ngo.showAll;

    let nextFilteredRows = filterRows(ngo.rows, ngo.selectedFilterOptions);
    nextFilteredRows = sortRows(nextFilteredRows, ngo.sortOptions);
    nextFilteredRows = nextFilteredRows.slice(
        0,
        ngo.showAll ? ngo.rows.length : INITIAL_MAX_ROWS,
    );
    ngo.filteredRows = nextFilteredRows;

    return nextState;
}
